<template>
  <VideoPlayer
    :id="videojsid"
    :src="videosrc"
    :poster="poster"
    :controls="isDefaultSontrols"
    :loop="loop"
    :volume="volume"
    :muted="muted"
    :autoplay="autoplay"
    :playsinline="playsinline"
    :playbackRate="playbackRate"
    :type="'m3u8'"
    @mounted="onVideoMounted"
    @ready="onReady"
    @play="onPlay"
    @pause="onPause"
    @ended="onEnded"
    @seeking="onSeeking"
    @progress="onProgress"
    @timeupdate="onTimeupdate"
    @durationchange="onDurationchange"
    @fullscreenchange="onFullscreenchange"
    @playbackrateschange="onPlaybackrateschange"
    @canplaythrough="onCanplaythrough"
    @error="onError"
  />
</template>


<script >
import { ref, toRefs, reactive , watch , onMounted, onUnmounted } from 'vue';
import { VideoPlayer } from '@videojs-player/vue';
import 'videojs-landscape-fullscreen';
import '@/assets/css/video-js.css';

export default {
  // eslint-disable-next-line vue/multi-word-component-names
    name: 'VideoJS',
    components: {
        VideoPlayer
    },
    props: {    
      videojsid:{
        type: String,
        required:true
      },
      autoplay:{
        type: Boolean,
        required:true
      },
      loop:{
        type: Boolean,
        required:true
      },
      
      onVideoJSMounted: {
        type: Function,
        required:true
      },
      onVideoReady: {
        type: Function,
        required:true
      },
      onVideoError: {
        type: Function,
        required:true
      },
      onVideoFullscreenchange: {
        type: Function,
        required:true
      },
      onVideoEnded: {
        type: Function,
        required:true
      },
      onVideoTimeupdate: {
        type: Function,
        required:true
      },
      onVideoDurationchange: {
        type: Function,
        required:true
      },  
      onVideoCanplaythrough: {
        type: Function,
        required:true
      }, 
      playerStatusChange: {
        type: Function,
        required:true
      },   
    },
    emits: [
    ],
    setup(props,{emit}) { 
      // props
      const { videojsid, autoplay, loop, onVideoJSMounted, onVideoReady, onVideoError, onVideoFullscreenchange, onVideoEnded, onVideoTimeupdate, playerStatusChange, onVideoDurationchange, onVideoCanplaythrough } = toRefs(props); 
      // enum  
      const MUTEDSTATE = {
          none: 'none',
          unmute: 'UnMute',
          mute: 'Mute',
      };   
      // const data      
      const videoPlayer = ref();
      const playbackRate = ref(1);
      const volume = ref(0.5);
      // const loop = ref(false);
      const poster = ref('');
      const videosrc = ref('');
      const isDefaultSontrols = ref(true);  
      const muted = ref(false);  
      const playsinline = ref(true);       

      onMounted(async () => {
      });  
      onUnmounted(async () => {
        if(videoPlayer.value && videoPlayer.value.player){
          videoPlayer.value.player.dispose();
        }
      });      

      function onVideoMounted(payload){
        videoPlayer.value = payload;
        if(videoPlayer.value && videoPlayer.value.player){
          videoPlayer.value.player.landscapeFullscreen({
            fullscreen:{
              enterOnRotate: true,
              exitOnRotate: true,
              alwaysInLandscapeMode: true,
              iOS: false
            }
          });
        }
        if(onVideoJSMounted.value && onVideoJSMounted.value != undefined && typeof onVideoJSMounted.value === 'function'){
          onVideoJSMounted.value();
        }
      }
      function onReady(value){
        if(onVideoReady.value && onVideoReady.value != undefined && typeof onVideoReady.value === 'function'){
          onVideoReady.value();
        }
      }
      function onPlay(value){
        if(playerStatusChange.value && playerStatusChange.value != undefined && typeof playerStatusChange.value === 'function'){
          playerStatusChange.value({
            'playing': true,
            'paused': false,
          });
        }
      }
      function onPause(value){
        if(playerStatusChange.value && playerStatusChange.value != undefined && typeof playerStatusChange.value === 'function'){
          playerStatusChange.value({
            'playing': false,
            'paused': true,
          });
        }
      }
      function onEnded(value){
        if(onVideoEnded.value && onVideoEnded.value != undefined && typeof onVideoEnded.value === 'function'){
          onVideoEnded.value();
        }
      }
      function onSeeking(value){
      }
      function onFullscreenchange(value){
        if(onVideoFullscreenchange.value && onVideoFullscreenchange.value != undefined && typeof onVideoFullscreenchange.value === 'function'){
          if(videoPlayer.value && videoPlayer.value.player){
            onVideoFullscreenchange.value(videoPlayer.value.player.isFullscreen());
          }else{
            onVideoFullscreenchange.value(false);
          }
        }
      }
      function onPlaybackrateschange(value){
      }
      function onCanplaythrough(value){
        if(onVideoCanplaythrough.value && onVideoCanplaythrough.value != undefined && typeof onVideoCanplaythrough.value === 'function'){          
          onVideoCanplaythrough.value();
        } 
      }
      function onProgress(value){
      }
      function onTimeupdate(value){
        if(onVideoTimeupdate.value && onVideoTimeupdate.value != undefined && typeof onVideoTimeupdate.value === 'function'){
          if(videoPlayer.value && videoPlayer.value.player){
            onVideoTimeupdate.value(videoPlayer.value.player.currentTime());
          }
        }        
      }
      function onDurationchange(value){
        if(onVideoDurationchange.value && onVideoDurationchange.value != undefined && typeof onVideoDurationchange.value === 'function'){
          onVideoDurationchange.value(getTotalVideoTime());
        }  
      }
      function onError(error){
        if(onVideoError.value && onVideoError.value != undefined && typeof onVideoError.value === 'function'){
          onVideoError.value(error);
        }
      }
      function setPlaybackRate(value){
        playbackRate.value = value;
      }
      function setVolume(value){
        if(videoPlayer.value && videoPlayer.value.player){
          videoPlayer.value.player.volume(value);
        }
      }
      function setPlaySeekToTime(time){
        if(videoPlayer.value && videoPlayer.value.player){
          videoPlayer.value.player.currentTime(time);
        }
      }
      function setMuted(value){
        if(videoPlayer.value && videoPlayer.value.player){
          videoPlayer.value.player.muted(value);
        }
      }
      function getCurrentVideoTime(){
        if(videoPlayer.value && videoPlayer.value.player){
          return videoPlayer.value.player.currentTime();
        }
        return 0;
      }
      function getTotalVideoTime(){
        if(videoPlayer.value && videoPlayer.value.player){
          return videoPlayer.value.player.duration();
        }
        return 0;
      }
      function getVolume(){
        if(videoPlayer.value && videoPlayer.value.player){
          return videoPlayer.value.player.volume();
        }else{
          return 0.5;
        }
      }
      function getMuted(){
        if(videoPlayer.value && videoPlayer.value.player){
          return videoPlayer.value.player.muted();
        }else{
          return false;
        }
      }
      function isPlaying(){
        if(videoPlayer.value && videoPlayer.value.state){
            return videoPlayer.value.state.playing;
        }
        return false;
      }
      function isMuted(){
        if(videoPlayer.value && videoPlayer.value.state){
          if(videoPlayer.value.state.muted == MUTEDSTATE.mute){
            return true;
          }else{
            return false;
          }
        }
        return false;
      }
      function play(callback){
        if(videoPlayer.value && videoPlayer.value.player && videoPlayer.value.state && videoPlayer.value.state.playing == false){
          videoPlayer.value.player.play();
        }
      }
      function pause(callback){
        if(videoPlayer.value && videoPlayer.value.player && videoPlayer.value.state && videoPlayer.value.state.playing == true){
          videoPlayer.value.player.pause(); 
        }
      }
      function onFullscreen(){
        if(videoPlayer.value && videoPlayer.value.player){
          if(videoPlayer.value.player.requestFullscreen){
            videoPlayer.value.player.requestFullscreen();
          }else if(videoPlayer.value.player.mozRequestFullscreen){
            videoPlayer.value.player.mozRequestFullscreen();
          }else if(videoPlayer.value.player.webkitRequestFullscreen){
            videoPlayer.value.player.webkitRequestFullscreen();
          }else if(videoPlayer.value.player.msRequestFullscreen){
            videoPlayer.value.player.msRequestFullscreen();
          }
        }        
      }
      function onLandscapeFullscreen(){
        if(videoPlayer.value && videoPlayer.value.player){
          // console.log("onLandscapeFullscreen");
        }
      }
      function setVideoSrc(value){
        videosrc.value = value;
      }
      function setPoster(value){
        poster.value = value;
      }
      
      function onExitFullscreen(){
        if(document.exitFullscreen){
          document.exitFullscreen();
        }else if(document.mozCancelFullScreen){
          document.mozCancelFullScreen();
        }else if(document.webkitExitFullscreen){
          document.webkitExitFullscreen();
        }else if(document.msExitFullscreen){
          document.msExitFullscreen();
        } 
      }

      return {
        // const data
        videoPlayer,          //播放器
        playbackRate,         //播放速度
        volume,               //影片音量
        // loop,                 //循環播放
        videosrc,             //影片路徑
        poster,               //預覽圖片路徑
        isDefaultSontrols,    //是否使用預設控制器
        muted,                //是否靜音(true = 靜音，false = 正常)
        playsinline,          //是否在網頁裡播放
        // function
        onVideoMounted,       //播放器建立完畢事件
        onReady,              //影片讀取完畢事件
        onPlay,               //播放影片事件
        onPause,              //暫停影片事件
        onEnded,              //影片播放完畢事件
        onSeeking,            //調整影片時間事件
        onFullscreenchange,   //全螢幕切換事件
        onPlaybackrateschange,//播放速率切換事件
        onCanplaythrough,     //可播放緩衝完事件
        onError,              //播放器異常事件
        onProgress,           //影片讀取進度事件
        onTimeupdate,         //影片時間更新事件
        onDurationchange,     //影片總時數更新事件
        setPlaybackRate,      //設定播放速度
        setPlaySeekToTime,    //設定影片時間
        setVolume,            //設定影片音量
        setMuted,             //設定影片靜音
        getCurrentVideoTime,  //取得當前影片時間
        getTotalVideoTime,    //取得影片總時間
        getVolume,            //取得影片音量
        getMuted,             //取得影片靜音
        isPlaying,            //影片是否播放中
        isMuted,              //影片是否靜音中
        play,                 //播放影片
        pause,                //暫停影片
        onFullscreen,         //播放器全螢幕
        onLandscapeFullscreen,//播放器橫版全螢幕
        onExitFullscreen,     //播放器離開全螢幕
        setVideoSrc,          //設定影片路徑
        setPoster,            //設定影片預覽圖
      };
    },
};
</script>
<style scope>
.noUi-origin{
  width: 100%;
}
</style>
